import { render, staticRenderFns } from "./PlaceTodosSantos.vue?vue&type=template&id=04f851aa&scoped=true&"
import script from "./PlaceTodosSantos.vue?vue&type=script&lang=js&"
export * from "./PlaceTodosSantos.vue?vue&type=script&lang=js&"
import style0 from "./PlaceTodosSantos.vue?vue&type=style&index=0&id=04f851aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f851aa",
  null
  
)

export default component.exports